import axios from 'axios';
import { isEmpty } from 'lodash';
import { BASE_URL } from 'config/env';

const BEARER = 'Bearer ';
const CONTENT_TYPE = 'application/json';
let headers = {
  'Content-Type': CONTENT_TYPE,
  Authorization: '',
};
let token;

const isTokenPresent = () => {
  return isEmpty(token);
};

const setHeaders = isFormData => {
  if (isFormData) {
    headers['Content-Type'] = 'multipart/form-data';
  }
  headers.Authorization = BEARER + token;
  return headers;
};

export const apiHeaders = isFormData => {
  if (!isTokenPresent()) {
    return setHeaders(isFormData);
  }
  return requestNewToken();
};

const requestNewToken = () => {
  const url = BASE_URL + 'token.json';
  return axios
    .get(url)
    .then(function(response) {
      token = response.data.data.token;
      return setHeaders();
    })
    .catch(function(error) {
      console.log('error', error);
    });
};

export const removeHeaders = () => {
  return (token = null);
};
